<template>
  <div>
    <div class="fixed inset-0 bg-blue-800"></div>

    <div v-if="dialogs.choiceDialog.show"
         class="modal fixed z-50 inset-0">
      <div class="modal-wrapper w-4/5 sm:w-1/2 lg:w-1/4 mt-10 mx-auto flex flex-col rounded bg-blue-700">
        <h1 class="modal-title m-2 text-white font-bold"
            style="text-align: center">Выбор колод</h1>
        <font-awesome-icon icon="check"
                           class="modal-close m-2 text-xl text-white"
                           @click="closeChoiceDialog"></font-awesome-icon>
        <div class="modal-content choice-wrapper w-full p-3 rounded bg-blue-800">
          <div v-for="subj in form.decks.nodes"
               :key="subj.name"
               class="pb-2">
            <div class="flex items-center">
              <input @change="recalcChecks(subj)"
                     v-model="subj.checked"
                     :id="subj.name"
                     type="checkbox"
                     :indeterminate.prop="subj.indeterminate"
                     class="mr-2">
              <label :for="subj.name"
                     class="text-white font-bold">{{ subj.name }}</label>
            </div>
            <div v-for="chapter in subj.nodes"
                 :key="chapter.name"
                 class="py-1">
              <div class="flex items-center pl-4">
                <input @change="recalcChecks(chapter)"
                       v-model="chapter.checked"
                       :id="chapter.name"
                       type="checkbox"
                       :indeterminate.prop="chapter.indeterminate"
                       class="mr-2">
                <label :for="chapter.name"
                       class="text-white">{{ chapter.name }}</label>
              </div>
              <div v-for="deck in chapter.nodes"
                   :key="deck.name">
                <div class="flex items-center pl-8">
                  <input @change="recalcChecks(deck)"
                         v-model="deck.checked"
                         :id="deck.name"
                         :indeterminate.prop="deck.indeterminate"
                         type="checkbox"
                         class="mr-2">
                  <label :for="deck.name"
                         class="text-white italic">{{ deck.name }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="navbar-top">
      <div class="header-wrapper">
        <div class="flex justify-center items-center">
          <font-awesome-icon icon="arrow-left"
                             class="text-white text-2xl"
                             @click="back"></font-awesome-icon>
        </div>
        <div class="flex justify-center items-center">
          <p class="text-2xl text-white font-semibold">Новая к/р</p>
        </div>
        <div class="flex justify-center items-center">

        </div>
      </div>
    </div>

    <div class="wrapper has-navbar-top has-navbar-bottom fixed inset-0"
         :class="{ 'overflow-hidden': isDialogDisplayed }">
      <div v-if="dataLoaded"
           class="flex flex-col p-4 md:px-3">
        <div class="flex justify-between items-center">
          <p class="text-xl text-white">Колоды:</p>
          <button class="py-1 px-4 rounded bg-blue-600 font-semibold text-sm text-white"
                  @click="openChoiceDialog">Добавить</button>
        </div>
        <div class="w-full my-2 p-2 overflow-y-scroll rounded bg-blue-900"
             style="height: 30vh">
          <div v-for="deck in selectedDecksSorted"
               :key="deck.deckId"
               class="w-full mb-2 py-2 px-2 rounded bg-blue-700">
            <p class="text-xs text-white">{{ deck.location.slice(1).join(' > ')}}</p>
            <p class="text-lg text-white">{{ deck.name }}</p>
          </div>
        </div>
        <div class="block w-56 m-auto">
          <div class="flex my-2 justify-between items-center">
            <label for="copNum"
                   class="pr-8 text-xl text-white">Учеников:</label>
            <input v-model="form.copNum"
                   :placeholder="form.placeholders.copNum"
                   id="copNum"
                   class="w-16 p-1 rounded text-center">
          </div>
          <div class="flex my-2 justify-between items-center">
            <label for="edNum"
                   class="pr-8 text-xl text-white">Вариантов:</label>
            <input v-model="form.edNum"
                   :placeholder="form.placeholders.edNum"
                   id="edNum"
                   class="w-16 p-1 rounded text-center">
          </div>
          <div class="flex my-2 justify-between items-center">
            <label for="tasksNum"
                   class="pr-8 text-xl text-white">Заданий:</label>
            <input v-model="form.tasksNum"
                   :placeholder="form.placeholders.tasksNum"
                   id="tasksNum"
                   class="w-16 p-1 rounded text-center">
          </div>
          <div class="flex mt-6 my-2 justify-left items-center">
            <input v-model="form.allowImgs"
                   type="checkbox"
                   id="allowImgs"
                   class="mr-2 rounded">
            <label for="allowImgs"
                   class="text-white">Показывать рисунки</label>
          </div>
          <div class="flex my-2 justify-left items-center">
            <input v-model="form.addAns"
                   type="checkbox"
                   id="addAns"
                   class="mr-2 rounded">
            <label for="addAns"
                   class="text-white">Добавить лист с ответами</label>
          </div>
        </div>
      </div>
      <menu-spinner v-else></menu-spinner>
    </div>

    <div class="navbar-bottom">
      <div class="footer-wrapper bg-blue-800">
        <button class="h-full w-full rounded bg-green-600 text-white text-2xl"
                @click="createTest">Создать</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import MenuSpinner from '@/components/MenuSpinner.vue';

export default {
  components: {
    MenuSpinner,
  },
  data () {
    return {
      dataLoaded: false,
      dialogs: {
        choiceDialog: {
          show: false,
        },
      },
      form: {
        decks: {
          name: '',
          nodes: [],
        },
        copNum: '',
        edNum: '',
        tasksNum: '',
        allowImgs: true,
        addAns: false,
        placeholders: {
          copNum: '2',
          edNum: '2',
          tasksNum: '11',
        },
      },
    };
  },
  computed: {
    ...mapState({
      deckTree: state => state.user.deckTree,
    }),
    selectedDecksSorted () {
      const selectedDecks = (function flattenNode (node, location) {
        if (node.name === 'root' || node.checked || node.indeterminate) {
          if (node.nodes.length > 0) {
            return node.nodes.reduce((a, c) => [...a, ...flattenNode(c, [...location, node.name])], []);
          }

          return [{ name: node.name, deckId: node.deckId, location }];
        }

        return [];
      }(this.form.decks, []));
      const deckIndex = deck => ({
        loc: deck.location.map(loc => loc.slice(0, 1)).join(''),
        deck: deck.name.slice(0, 3),
      });

      return selectedDecks ? selectedDecks.sort((deckA, deckB) => (deckIndex(deckA).loc).localeCompare(deckIndex(deckB).loc, undefined, { numeric: true, sensitivity: 'base' })
          || (deckIndex(deckA).deck).localeCompare(deckIndex(deckB).deck, undefined, { numeric: true, sensitivity: 'base' })) : [];
    },
    isDialogDisplayed () {
      return this.dialogs.choiceDialog.show;
    },
  },
  created () {
    this.$store.dispatch('user/fetchTeachersTree')
      .then(() => {
        this.generateDecksModel();
        this.dataLoaded = true;
      });
  },
  methods: {
    generateDecksModel () {
      this.form.decks = (function addCheckedField (node) {
        node.checked = false;
        node.indeterminate = false;
        if (node.nodes && node.nodes instanceof Array) {
          node.nodes = node.nodes.sort((nodeA, nodeB) => nodeA.name.localeCompare(nodeB.name, undefined, { numeric: true, sensitivity: 'base' }));
          node.nodes.map(n => addCheckedField(n));
        }

        return node;
      }({ ...this.deckTree }));
    },
    recalcChecks (selNode) {
      (function toggleChildren (node, value) {
        node.checked = value;
        node.indeterminate = false;
        if (node.nodes.length > 0) {
          node.nodes.map(n => toggleChildren(n, value));
        }
        return true;
      }(selNode, selNode.checked));

      (function toggleParent (node) {
        const parent = node.parentNode;
        if (parent) {
          parent.checked = parent.nodes.reduce((a, c) => a && c.checked, true);
          parent.indeterminate = !parent.checked
            && parent.nodes.reduce((a, c) => a || (c.checked || c.indeterminate), false);
          toggleParent(parent);
        }
        return true;
      }(selNode));

      const buf = this.form.decks;
      this.form.decks = {};
      this.form.decks = buf;
    },
    openChoiceDialog () {
      this.dialogs.choiceDialog.show = true;
    },
    closeChoiceDialog () {
      this.dialogs.choiceDialog.show = false;
    },
    createTest () {
      const decks = this.selectedDecksSorted.map(deck => deck.deckId).join(',');
      if (decks) {
        const copies = this.form.copNum || this.form.placeholders.copNum;
        const eds = this.form.edNum || this.form.placeholders.edNum;
        const tasks = this.form.tasksNum || this.form.placeholders.tasksNum;
        const img = this.form.allowImgs;
        const ans = this.form.addAns;
        this.$router.push(`/test?decks=${decks}&copies=${copies}&eds=${eds}&tasks=${tasks}&img=${img}&ans=${ans}`);
      } else {
        alert('Добавьте колоды, по которым нужно создать контрольную.');
      }
    },
    back () {
      this.$router.push('/');
    },
  },
};
</script>

<style scoped>
  input[type=checkbox] {  flex: 1;  }
  label {  flex: 12;  }

  .modal {
    background-color: rgba(0,0,0,0.7);
  }

  .modal-wrapper {
    display: grid;
    grid-template-columns: 2.5rem 1fr 2.5rem;
    grid-template-rows: auto 1fr;
    grid-template-areas:  "modal-head-left modal-head-center modal-head-right"
                          "modal-main modal-main modal-main";
  }

  .modal-title {
    grid-area: modal-head-center;
    align-self: center;
    justify-self: center;
  }

  .modal-close {
    grid-area: modal-head-right;
    align-self: center;
    justify-self: center;
  }

  .modal-back {
    grid-area: modal-head-left;
    align-self: center;
    justify-self: center;
  }

  .modal-content {
    overflow-y: scroll;
    grid-area: modal-main;
  }

  .choice-wrapper {
    max-height: 65vh;
    overflow: scroll;
  }
</style>
